export default __webpack_public_path__ + "static/media/spotlight-shadow.fa3985bd.webp";